__turbopack_context__.v({
  "className": "inter_63b7004f-module__qa3Bbq__className",
  "variable": "inter_63b7004f-module__qa3Bbq__variable",
});
